<div class="content-wrapper d-print-none">
  <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
              <div class="card-body">
                  <h4 class="card-title">Recruitments</h4>
                  <div class="input-group-append">
                      <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                  </div>
                  <div class="table-responsive pt-3">
                      <nz-table #ManPowerTable [nzData]="Requests" [nzPageSize]="50">
                          <thead>

                              <tr>
                                  <th>
                                      #
                                  </th>

                                  <th>
                                      Request Date
                                  </th>

                                  <th>
                                      Requester Name
                                  </th>

                                  <th>
                                      Requester Designation
                                  </th>

                                  <th>
                                      Required Role
                                  </th>



                                  <th>
                                      Location
                                  </th>



                                  <th>
                                      Vacancy Status
                                  </th>
                                  <th>
                                      Action
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let data of ManPowerTable.data; let i = index ;">

                                  <td>
                                      {{i+1}}
                                  </td>
                                  <td>
                                      {{ data.createdDate | date: 'dd MMMM yyy' }}
                                  </td>



                                  <td>
                                      {{data.requesterName}}
                                  </td>

                                  <td>
                                      {{data.requesterDesignation}}
                                  </td>

                                  <td>
                                      {{data.jobTitle}}
                                  </td>



                                  <td>
                                      {{data?.location}}
                                  </td>

                                  <td>
                                      <button [ngClass]="getStatusColor(data.vacancyStatus)"> {{data.vacancyStatus}}</button>
                                  </td>
                                  <td>

                                      <div class="dropdown">
                                          <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     
                    </button>
                                          <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">
                                              <a class="dropdown-item" (click)="open(data)">View Request Info</a>
                                              <div class="dropdown-divider"></div>
                                              <a class="dropdown-item" (click)="openRecruitment(data)">View Recruitment Info</a>
                                              <div class="dropdown-divider"></div>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Pending')" (click)="openStartAdvert(data)">Start Advert</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Advert_Ongoing')" (click)="openEndAdvert(data)">End Advert</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Advert_Ended')" (click)="openStartShortlisting(data)">Start ShortListing</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Shortlisting_Ongoing')" (click)="openEndShortlisting(data)">End ShortListing</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Shortlisting_Concluded')" (click)="openStartInterview(data)">Start Interview</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Interview_Ongoing')" (click)="openEndInterview(data)">End Interview</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'Interview_Concluded')" (click)="openStartOfferManagement(data)">Start Offer Management</a>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'OfferManagement_Ongoing')" (click)="openEndOfferManagement(data)">End Offer Management</a>
                                              
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'OfferManagement_Concluded')" (click)="openOfferAccepted(data)">Accept Offer</a>
                                              <div class="dropdown-divider"></div>
                                              <a class="dropdown-item" *ngIf="populateoNHoldDrowdown(data,'OnHold')" (click)="openOnHold(data)">On Hold</a> 
                                              <div class="dropdown-divider"></div>
                                              <a class="dropdown-item" *ngIf="populateDrowdown(data,'OfferAccepted')" (click)="openCloseRecruitment(data)">Close Recruitment</a>
                                             <div class="dropdown-divider"></div>
                                              <a 
                                                    class="dropdown-item" 
                                                     *ngIf="populateDrowdown(data,'Active')"
                                                    (click)="openCloseRecruitmentNew(data)">
                                                    Close
                                                    </a>
                                              <div class="dropdown-divider"></div>


                                              <!-- <a class="dropdown-item" *ngIf="OfferAcceptedVisible" (click)="openapproval(data)">Offer Accepted</a>
                                              <a class="dropdown-item" *ngIf="onHoldVisible" (click)="openapproval(data)">On Hold</a> -->
                                          </div>
                                      </div>
                                  </td>
                              </tr>
                          </tbody>
                      </nz-table>

                  </div>
              </div>
          </div>
      </div>


  </div>
</div>
<!-- Context Menu  -->
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
      <li nz-menu-item>1st menu item</li>
      <li nz-menu-item>2nd menu item</li>
      <li nz-menu-divider></li>
  </ul>
</nz-dropdown-menu>


<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040" [nzVisible]="ViewManpowerRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block" id="detailSection">
      <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
              <div class="row">
                  <div class="col">
                      <h5 class="card-title"> Manpower Request Details</h5>
                  </div>
                  <div class="col">
                      <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
                  </div>
              </div>


              <div class="card-body">




                  <h5>REQUESTOR DETAILS</h5>
                  <br>
                  <div class="row">

                      <div class="col">
                          <label><b>Request Reference</b></label>
                          <p>{{ UpdateRequest?.reference }}</p>
                      </div>
                      <div class="col">
                          <label><b>Requester Name</b></label>
                          <p>{{ UpdateRequest?.requesterName }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Requester Function</b></label>
                          <p>{{ UpdateRequest?.requesterFunction }}</p>
                      </div>
                      <div class="col">
                          <label><b>Requester Unit</b></label>
                          <p>{{ UpdateRequest?.requesterUnit }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Requester Designation</b></label>
                          <p>{{ UpdateRequest?.requesterDesignation }}</p>
                      </div>
                      <div class="col">
                          <label><b>Request Date</b></label>
                          <p>{{ UpdateRequest?.requestDate | date: 'dd MMMM yyyy' }}</p>
                      </div>
                  </div>
                  <div class="row">

                      <div class="col">
                          <label><b>Reason For Vacancy</b></label>
                          <p>{{ UpdateRequest?.reasonForVacancy }}</p>
                      </div>
                      <div class="col">
                          <label><b>Job Title</b></label>
                          <p>{{ UpdateRequest?.jobTitle }}</p>
                      </div>

                  </div>
              </div>

              <!-- <hr *ngIf="!editing"> -->

              <!-- Non Editable View -->
              <!-- <div class="card-body" *ngIf="!editing">
        <div class="row">

          <div class="col">
            <label><b>Request Date</b></label>
            <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
          </div>

          <div class="col">
            <label><b>Contract Duration (Month)</b></label>
            <p>{{ UpdateRequest?.contractDuration }}</p>
          </div>
        </div>

        <div class="row">

          <div class="col">
            <label><b>Expected Start Date</b></label>
            <p>{{ UpdateRequest?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
          </div>

          <div class="col">
            <label><b>Number of Staff</b></label>
            <p>{{ UpdateRequest?.noOfStaff }}</p>
          </div>
        </div>

        <div class="row">

          <div class="col">
            <label><b>Medical Notes </b></label>
            <p>{{ UpdateRequest?.medicalNotes  }}</p>
          </div>

          <div class="col">
            <label><b> Active Number of Employees</b></label>
            <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
          </div>
        </div>


        <div class="row">

          <div class="col">
            <label><b>Budget Cost</b></label>
            <p>{{ UpdateRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
          </div>

          <div class="col">
            <label><b>Requested By</b></label>
            <p>{{ UpdateRequest?.createdBy }}</p>
          </div>
        </div>

       
       

        </div> -->
              <div class="card-body">
                  <div class="row">

                      <div class="col">
                          <label><b>N + 1 Designation</b></label>
                          <p>{{ UpdateRequest?.nPlus1Designation }}</p>
                      </div>

                      <div class="col">
                          <label><b>Band</b></label>
                          <p>{{ UpdateRequest?.band }}</p>
                      </div>

                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Cost Center</b></label>
                          <p>{{ UpdateRequest?.costCenter }}</p>
                      </div>
                      <div class="col">
                          <label><b>Location</b></label>
                          <p>{{ UpdateRequest?.location }}</p>
                      </div>


                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Date Vacancy Occured</b></label>
                          <p>{{ UpdateRequest?.dateVacancyOccurred | date: 'dd MMMM yyyy'}}</p>
                      </div>

                      <div class="col">
                          <label><b>Required Number</b></label>
                          <p>{{ UpdateRequest?.requiredNumber }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Type Of Vacancy</b></label>
                          <p>{{ UpdateRequest?.typeOfVacancy }}</p>
                      </div>
                      <div class="col">
                          <label><b>Reason For Vacancy</b></label>
                          <p>{{ UpdateRequest?.reasonForVacancy }}</p>
                      </div>



                  </div>
                  <div class="row">
                      <div class="col">
                          <label><b>Mode Of Recruitment</b></label>
                          <p>{{ UpdateRequest?.modeOfRecruitment }}</p>
                      </div>

                      <div class="col">
                          <label><b>Duration Of Contract</b></label>
                          <p>{{ UpdateRequest?.durationOfContract }}</p>
                      </div>

                  </div>

                  <div class="row">
                      <div class="col">
                          <label><b>Estimated Annual Cost</b></label>
                          <p>{{ UpdateRequest?.estimatedAnnualCost }}</p>
                      </div>

                      <div class="col">
                          <label><b>Justification For Vacancy</b></label>
                          <p>{{ UpdateRequest?.justificationForVacancy }}</p>
                      </div>

                  </div>
                  <div class="row">

                      <div class="col">
                          <label><b>Request Date</b></label>
                          <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
                      </div>

                      <div class="col">
                          <label><b>Educational Qualification</b></label>
                          <p>{{ UpdateRequest?.qualification }}</p>
                      </div>
                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Skills Required</b></label>
                          <p>{{ UpdateRequest?.skillsRequired }}</p>
                      </div>

                      <div class="col">
                          <label><b>Experience</b></label>
                          <p>{{ UpdateRequest?.experience }}</p>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col">
                          <label><b>Syetem Requirements</b></label>
                          <p>{{ UpdateRequest?.systemRequired }}</p>
                      </div>

                      <div class="col">
                          <label><b>Requested By</b></label>
                          <p>{{ UpdateRequest?.createdBy }}</p>
                      </div>

                  </div>

                  <div class="row">

                      <div class="col">
                          <label><b>Other System Required</b></label>
                          <p>{{ UpdateRequest?.otherSystemRequirements }}</p>
                      </div>
                  </div>

                  <hr *ngIf="ViewlevelOfCompliance">
                  <div class="row" *ngIf="ViewlevelOfCompliance">
                      <div class="col">
                          <label><b>Approved Budget For The Department</b></label>
                          <p>{{ UpdateRequest?.presentDepartmentManpowerFigure }}</p>
                      </div>
                      <div class="col">

                          <label><b>Present Manpower Figure For The Department</b></label>
                          <p>{{ UpdateRequest?.presentDepartmentManpowerFigure }}</p>
                      </div>
                      <div class="col">
                          <label><b>Level of Risk Exposure(Compliance)</b></label>
                          <br>
                          <p [ngClass]="getColor(UpdateRequest?.levelOfExposureCompliance)">{{ UpdateRequest?.levelOfExposureCompliance }} </p>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col">
                          <div class="col pull right">
                              <button (click)="getJD(UpdateRequest)">Download Job Description</button>
                          </div>

                      </div>

                      <div class="col">
                          <div class="col pull right">
                              <nz-space>

                                  <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument(UpdateRequest)">View document</button>
                              </nz-space>
                          </div>
                      </div>


                  </div>
                  <hr>
                  <div class="card-body">
                      <h5 class="card-title">Approvals</h5>
                      <div class="table-responsive" *ngIf="ManPowerRequestApprovals?.length">
                          <table class="table table--striped table-hover">
                              <thead>
                                  <tr>
                                      <th>
                                          Designation Name
                                      </th>
                                      <th>
                                          Approved By
                                      </th>
                                      <th>
                                          Date Approved
                                      </th>
                                      <th>
                                          Message
                                      </th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let approval of ManPowerRequestApprovals">
                                      <td>{{approval.designationName}}</td>
                                      <td>{{approval.approvedBy}}</td>
                                      <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
                                      <td>{{approval.message}}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      

                      <div *ngIf="!ManPowerRequestApprovals?.length" style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
                          <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
                      </div>

                  </div>
              </div>
              <ng-template #footerTpl>
                <div style="float: right" class="d-print-none">
  
                    <button class="btn btn-primary" style="margin-right: 8px;" (click)="print(UpdateRequest?.reference, 'detailSection')" *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'">Print</button>
                    <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>
  
                </div>
  
  
            </ng-template>
          </div>
      </div>
  
  
              <!-- Cancel Request Modal  -->
        
              <!-- View Start Advert Modal  -->
              <nz-modal [(nzVisible)]="isStartAdvertRecruitmentVisible" nzTitle="Start Advert" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Advert Start Date:</label>
                              <input type="date" class="form-control" id="advertStartDate" [(ngModel)]="advertStartDate" name="advertStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartAdvert()">Approve</button>
                  </div>

              </nz-modal>
              <!-- View End Advert Modal  -->
              <nz-modal [(nzVisible)]="isEndAdvertRecruitmentVisible" nzTitle="End Advert" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Advert End Date:</label>
                              <input type="date" class="form-control" id="advertEndDate" [(ngModel)]="advertEndDate" name="advertEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndAdvert()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View Start Shortlisting Modal  -->
              <nz-modal [(nzVisible)]="isstartShortlistingRecruitmentVisible" nzTitle="Start ShortListing" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">ShortListing Start Date:</label>
                              <input type="date" class="form-control" id="shortlistingStartDate" [(ngModel)]="shortlistingStartDate" name="shortlistingStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartShortlisting()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View End Shortlisting Modal  -->
              <nz-modal [(nzVisible)]="isEndShortlistingRecruitmentVisible" nzTitle="End ShortListing" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">ShortListing End Date:</label>
                              <input type="date" class="form-control" id="shortlistingEndDate" [(ngModel)]="shortlistingEndDate" name="shortlistingEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndShortlisting()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View Start Interview Modal  -->
              <nz-modal [(nzVisible)]="isStartInterviewRecruitmentVisible" nzTitle="Start Interview" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Interview Start Date:</label>
                              <input type="date" class="form-control" id="interviewStartDate" [(ngModel)]="interviewStartDate" name="interviewStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartInterview()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View End Interview Modal  -->
              <nz-modal [(nzVisible)]="isEndInterviewRecruitmentVisible" nzTitle="End Interview" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Interview End Date:</label>
                              <input type="date" class="form-control" id="interviewEndDate" [(ngModel)]="interviewEndDate" name="interviewEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndInterview()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View Start Offer Management Modal  -->
              <nz-modal [(nzVisible)]="isStartOfferRecruitmentVisible" nzTitle="Start Offer Management" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Offer Management Start Date:</label>
                              <input type="date" class="form-control" id="offerManagementStartDate" [(ngModel)]="offerManagementStartDate" name="offerManagementStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartOfferManagement()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View End Offer Management  Modal  -->
              <nz-modal [(nzVisible)]="isEndOfferRecruitmentVisible" nzTitle="End Offer Management" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Offer Management End Date:</label>
                              <input type="date" class="form-control" id="offerManagementEndDate" [(ngModel)]="offerManagementEndDate" name="offerManagementEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndOfferManagement()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View On Hold  Modal  -->
              <nz-modal [(nzVisible)]="isOnHoldRecruitmentVisible" nzTitle="Put On Hold" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Put On Hold Date:</label>
                              <input type="date" class="form-control" id="onHoldDate" [(ngModel)]="onHoldDate" name="onHoldDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendOnHold()">Approve</button>
                  </div>

              </nz-modal>
                            <!-- closing internal/external   Modal  -->

<nz-modal [(nzVisible)]="isCloseInternalOrExternalVisible" nzTitle="Close Internal/External" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Put On Hold Date:</label>
                              <input type="date" class="form-control" id="onHoldDate" [(ngModel)]="onHoldDate" name="onHoldDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendOnHold()">Approve</button>
                  </div>

              </nz-modal>
              <!-- View Accept Offer Modal  -->
              <nz-modal [(nzVisible)]="isAcceptOfferRecruitmentVisible" nzTitle="Accept Offer" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Accept Offer Date:</label>
                              <input type="date" class="form-control" id="acceptOfferDate" [(ngModel)]="acceptOfferDate" name="acceptOfferDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendAcceptOffer()">Approve</button>
                  </div>

              </nz-modal>

              <!-- View close Recruitment  Modal  -->
              <nz-modal [(nzVisible)]="isCloseRecruitmentVisible" nzTitle="Close Recruitment" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Recruitment Closed Date:</label>
                              <input type="date" class="form-control" id="recruitmentClosedDate" [(ngModel)]="recruitmentClosedDate" name="recruitmentClosedDate" required>
                          </div>
                          <div class="form-group">
                              <label for="exampleInputCity1">Assumption Date:</label>
                              <input type="date" class="form-control" id="assumptionDate" [(ngModel)]="assumptionDate" name="assumptionDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendCloseRecruitment()">Close Recruitment</button>
                  </div>

              </nz-modal>

          </div>
          <!-- Side swipe content -->
         
          
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040" [nzVisible]="ViewManpowerRecruitment" [nzFooter]="footerTpls" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block" id="detailSections">
      <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
              <div class="row">
                  <div class="col">
                      <h5 class="card-title"> Recruitment Details</h5>
                  </div>
                  <div class="col">
                      <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
                  </div>
              </div>


              <div class="card-body">

                  <h5>RECRUITMENT DETAILS</h5>
                  <br>
                  <div class="row">

                      <div class="col">
                          <label><b>Vacancy Status</b></label>
                          <p>{{ UpdateRequest?.vacancyStatus }}</p>
                      </div>
                      
                  </div>

                  <div class="row" *ngIf="advertVisible">
                    <div class="col">
             
                      <label><b>Advert Start Date</b></label>
                      <p>{{ UpdateRequest?.advertStartDate | date: 'dd MMMM yyyy'}}</p>

                  </div>

                  <div class="col">
             
                    <label><b>Advert Start Message</b></label>
                    <p>{{ UpdateRequest?.advertStartMessage }}</p>
                    
                </div>
              </div>
              <div class="row" *ngIf="advertEndVisible">
                <div class="col">
                  <label><b>Advert End Date</b></label>
                  <p>{{ UpdateRequest?.advertEndDate | date: 'dd MMMM yyyy'}}</p>
              </div>
              <div class="col">
                  <label><b>Advert End Message</b></label>
                  <p>{{ UpdateRequest?.advertStartMessage }}</p>
              </div>
              </div>

              <div class="row" *ngIf="advertEndVisible">

              <div class="col">
                  <label><b>Advert Duration</b></label>
                  <p>{{ advertDuration}}</p>
              </div>
              </div>
                   
              </div>

          
       
              <div class="card-body">
                  <div class="row" *ngIf="shortListingVisible">

                      <div class="col">
                          <label><b>Shortlisting Start Date</b></label>
                          <p>{{ UpdateRequest?.shortlistingStartDate | date: 'dd MMMM yyyy'}}</p>
                      </div>

                      <div class="col">
                          <label><b>Shortlisting Start Message</b></label>
                          <p>{{ UpdateRequest?.shortListingStartMessage }}</p>
                      </div>

                  </div>

                  <div class="row" *ngIf="shortListingEndVisible">

                      <div class="col">
                          <label><b>Shortlisting End Date</b></label>
                          <p>{{ UpdateRequest?.shortlistingEndDate | date: 'dd MMMM yyyy'}}</p>
                      </div>
                      <div class="col">
                          <label><b>Shortlisting End Message</b></label>
                          <p>{{ UpdateRequest?.shortListingEndMessage }}</p>
                      </div>

                  </div>

                  <div class="row" *ngIf="shortListingEndVisible">

                      <div class="col">
                          <label><b>ShortListing Duration</b></label>
                          <p>{{ shortListingDuration}}</p>
                      </div>
                  </div>

                  <div class="row" *ngIf="interviewVisible">

                      <div class="col">
                          <label><b>Interview Start Date</b></label>
                          <p>{{ UpdateRequest?.interviewStartDate | date: 'dd MMMM yyyy'}}</p>
                      </div>
                      <div class="col">
                          <label><b>Interview Start Message</b></label>
                          <p>{{ UpdateRequest?.interviewStartMessage }}</p>
                      </div>



                  </div>
                  <div class="row" *ngIf="interviewEndVisible">
                      <div class="col">
                          <label><b>Interview End Date</b></label>
                          <p>{{ UpdateRequest?.interviewEndDate | date: 'dd MMMM yyyy'}}</p>
                      </div>

                      <div class="col">
                          <label><b>Interview End Message</b></label>
                          <p>{{ UpdateRequest?.interviewEndMessage }}</p>
                      </div>

                  </div>

                  <div class="row" *ngIf="interviewEndVisible">
                      <div class="col">
                          <label><b>Interview Duration</b></label>
                          <p>{{ interviewDuration}}</p>
                      </div>

                  </div>
                  <div class="row" *ngIf="OfferProcessVisible">

                      <div class="col">
                          <label><b>Offer Process Start Date</b></label>
                          <p>{{ UpdateRequest?.offerProcessStartDate | date: 'dd MMMM yyyy' }}</p>
                      </div>

                      <div class="col">
                          <label><b>Offer Process Start Message</b></label>
                          <p>{{ UpdateRequest?.offerProcessStartMessage }}</p>
                      </div>
                  </div>

               
                  <div class="row" *ngIf="OfferProcessEndVisible">

                    <div class="col">
                        <label><b>Offer Process End Date</b></label>
                        <p>{{ UpdateRequest?.offerProcessEndDate | date: 'dd MMMM yyyy'}}</p>
                    </div>

                    <div class="col">
                        <label><b>Offer Process End Message</b></label>
                        <p>{{ UpdateRequest?.offerProcessEndMessage }}</p>
                    </div>
                </div>

                <div class="row" *ngIf="OfferProcessEndVisible">
                    <div class="col">
                        <label><b>Offer Process Duration</b></label>
                        <p>{{ OfferProcessDuration }}</p>
                    </div>
                </div>

                <div class="row" *ngIf="acceptOfferVisible">

                  <div class="col">
                      <label><b>Accept Offer Start Date</b></label>
                      <p>{{ UpdateRequest?.acceptanceDate | date: 'dd MMMM yyyy'}}</p>
                  </div>

                  <div class="col">
                      <label><b>Accept Offer  Message</b></label>
                      <p>{{ UpdateRequest?.acceptanceMessage }}</p>
                  </div>
              </div>

              <div class="row" *ngIf="acceptOfferVisible">

                <div class="col">
                    <label><b>First Name:</b></label>
                    <p>{{ UpdateRequest?.employedFirstname }}</p>
                </div>

                <div class="col">
                    <label><b>Last Name:</b></label>
                    <p>{{ UpdateRequest?.employedLastname }}</p>
                </div>
            </div>

            <div class="row" *ngIf="acceptOfferVisible">

                <div class="col">
                    <label><b>Other Name:</b></label>
                    <p>{{ UpdateRequest?.employedMiddleName}}</p>
                </div>

                <div class="col">
                    <label><b>Band:</b></label>
                    <p>{{ UpdateRequest?.employedGrade }}</p>
                </div>
            </div>


              </div>
            </div>
            <ng-template #footerTpls>
                <div style="float: right" class="d-print-none">
    
                    <button class="btn btn-primary" style="margin-right: 8px;" (click)="prints(UpdateRequest?.reference, 'detailSections')" *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'">Print</button>
                    <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>
    
                </div>
    
    
            </ng-template>
        </div>
      
      </div>
              <!-- View Start Advert Modal  -->
              <nz-modal [(nzVisible)]="isStartAdvertRecruitmentVisible" nzTitle="Start Advert" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Advert Start Date:</label>
                              <input type="date" class="form-control" id="advertStartDate" [(ngModel)]="advertStartDate" name="advertStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartAdvert()">OK</button>
                  </div>

              </nz-modal>
              <!-- View End Advert Modal  -->
              <nz-modal [(nzVisible)]="isEndAdvertRecruitmentVisible" nzTitle="End Advert" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Advert End Date:</label>
                              <input type="date" class="form-control" id="advertEndDate" [(ngModel)]="advertEndDate" name="advertEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndAdvert()">OK</button>
                  </div>

              </nz-modal>

              <!-- View Start Shortlisting Modal  -->
              <nz-modal [(nzVisible)]="isstartShortlistingRecruitmentVisible" nzTitle="Start ShortListing" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">ShortListing Start Date:</label>
                              <input type="date" class="form-control" id="shortlistingStartDate" [(ngModel)]="shortlistingStartDate" name="shortlistingStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartShortlisting()">OK</button>
                  </div>

              </nz-modal>

              <!-- View End Shortlisting Modal  -->
              <nz-modal [(nzVisible)]="isEndShortlistingRecruitmentVisible" nzTitle="End ShortListing" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">ShortListing End Date:</label>
                              <input type="date" class="form-control" id="shortlistingEndDate" [(ngModel)]="shortlistingEndDate" name="shortlistingEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndShortlisting()">OK</button>
                  </div>

              </nz-modal>

              <!-- View Start Interview Modal  -->
              <nz-modal [(nzVisible)]="isStartInterviewRecruitmentVisible" nzTitle="Start Interview" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Interview Start Date:</label>
                              <input type="date" class="form-control" id="interviewStartDate" [(ngModel)]="interviewStartDate" name="interviewStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartInterview()">OK</button>
                  </div>

              </nz-modal>

              <!-- View End Interview Modal  -->
              <nz-modal [(nzVisible)]="isEndInterviewRecruitmentVisible" nzTitle="End Interview" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Interview End Date:</label>
                              <input type="date" class="form-control" id="interviewEndDate" [(ngModel)]="interviewEndDate" name="interviewEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndInterview()">OK</button>
                  </div>

              </nz-modal>

              <!-- View Start Offer Management Modal  -->
              <nz-modal [(nzVisible)]="isStartOfferRecruitmentVisible" nzTitle="Start Offer Management" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Offer Management Start Date:</label>
                              <input type="date" class="form-control" id="offerManagementStartDate" [(ngModel)]="offerManagementStartDate" name="offerManagementStartDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendStartOfferManagement()">OK</button>
                  </div>

              </nz-modal>

              <!-- View End Offer Management  Modal  -->
              <nz-modal [(nzVisible)]="isEndOfferRecruitmentVisible" nzTitle="End Offer Management" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Offer Management End Date:</label>
                              <input type="date" class="form-control" id="offerManagementEndDate" [(ngModel)]="offerManagementEndDate" name="offerManagementEndDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendEndOfferManagement()">OK</button>
                  </div>

              </nz-modal>

              <!-- View On Hold  Modal  -->
              <nz-modal [(nzVisible)]="isOnHoldRecruitmentVisible" nzTitle="Put On Hold" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Put On Hold Date:</label>
                              <input type="date" class="form-control" id="onHoldDate" [(ngModel)]="onHoldDate" name="onHoldDate" required>
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="presentManPowerFigure" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendOnHold()">OK</button>
                  </div>

              </nz-modal>

              <!-- View Accept Offer Modal  -->
              <nz-modal [(nzVisible)]="isAcceptOfferRecruitmentVisible" nzTitle="Accept Offer" (nzOnCancel)="handleCancel()">

                  <div *nzModalContent>
                      <div class="col">
                          <div class="form-group">
                              <label for="exampleInputCity1">Accept Offer Date:</label>
                              <input type="date" class="form-control" id="acceptOfferDate" [(ngModel)]="acceptOfferDate" name="acceptOfferDate" required>
                          </div>
                          <div class="form-group">
                            <label for="exampleInputCity1">First Name:</label>
                            <input type="text" class="form-control" id="firstName" [(ngModel)]="firstName" name="firstName" required>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputCity1">Middle Name:</label>
                            <input type="text" class="form-control" id="middleName" [(ngModel)]="middleName" name="middleName" required>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputCity1">Last Name:</label>
                            <input type="text" class="form-control" id="message" [(ngModel)]="lastName" name="lastName" required>
                        </div>

                        <div class="form-group">
                            <label for="costCenter">Band</label>
                            <ng-select required [(ngModel)]="Band"  id="band" name="band" #bandss="ngModel" >
                              <ng-option *ngFor="let b of band" [value]="b.name">{{b.name}}
                                </ng-option>
                            </ng-select>
          
                          </div>

                          <div class="form-group">
                              <label for="exampleInputCity1">Message:</label>
                              <input type="text" class="form-control" id="message" [(ngModel)]="message" name="message" required>
                          </div>
                      </div>
                  </div>

                  <div *nzModalFooter>
                      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
                      <button class="btn btn-primary" (click)="sendAcceptOffer()">OK</button>
                  </div>

              </nz-modal>

             <!-- View close Recruitment  Modal  -->


<nz-modal [(nzVisible)]="isCloseInternalOrExternalVisible" 
          nzTitle="Close Recruitment" 
          (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="col">

      <!-- Closing Remark -->
      <div class="form-group">
        <label for="message">Closing Remark:</label>
        <input type="text" class="form-control" id="message" 
               [(ngModel)]="message" name="message" required>
      </div>

      <!-- Hire Type -->
      <div class="form-group">
        <label>Hire Type:</label>
        <select class="form-control" [(ngModel)]="hireType" name="hireType" required>
          <option value="">-- Select Hire Type --</option>
          <option value="internal">Internal</option>
          <option value="external">External</option>
        </select>
      </div>

      <!-- Show only when Internal is selected -->
      <div *ngIf="hireType === 'internal'">
        <div class="form-group">
          <label for="recruitmentCloseDate">Recruitment Close Date:</label>
          <input type="date" class="form-control" id="recruitmentClosedDate"
                 [(ngModel)]="recruitmentClosedDate" name="recruitmentClosedDate" required>
        </div>

        <div class="form-group">
          <label for="assumptionDate">Assumption Date:</label>
          <input type="date" class="form-control" id="assumptionDate"
                 [(ngModel)]="assumptionDate" name="assumptionDate" required>
        </div>
      </div>

    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="handleCloseRecruitment()">
      {{ hireType === 'external' ? 'Onboard New Hire' : 'Close Recruitment' }}
    </button>
  </div>

</nz-modal>
          
          <!-- Side swipe content -->
          <!-- <ng-template #footerTpl>
              <div style="float: right" class="d-print-none">

                  <button class="btn btn-primary" style="margin-right: 8px;" (click)="print(UpdateRequest?.reference, 'detailSection')" *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'">Print</button>
                  <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>

              </div>


          </ng-template> -->